(() => {
  const configElement = document.getElementById('b2b-session-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  if (config.designMode) return;

  if (!config.isB2B) {
    for (const link of document.querySelectorAll('a[data-b2b-login]')) {
      const loginUrl = new URL(link.href, window.location.origin);
      if (loginUrl.origin !== window.location.origin || loginUrl.pathname !== '/customer_authentication/login') continue;
      const returnUrl = new URL(config.portalPath, window.location.origin);
      const currentUrl = new URL(window.location.href);
      for (const key of ['preview_theme_id', '_fd', 'pb']) {
        if (currentUrl.searchParams.has(key)) returnUrl.searchParams.set(key, currentUrl.searchParams.get(key));
      }
      loginUrl.searchParams.set('return_to', returnUrl.pathname + returnUrl.search);
      link.href = loginUrl.pathname + loginUrl.search;
    }
    return;
  }

  window.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-b2b-account]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(config.accountUrl);
  }, true);

  if (window.location.hash.startsWith('#rivo')) {
    const url = new URL(window.location.href);
    url.hash = '';
    window.history.replaceState(window.history.state, '', url);
  }
})();
